<template>
    <form @submit.prevent="submit">
        <div class="form-label-group">
            <input autocomplete="off" autofocus class="form-control"
                   data-vv-validate-on="blur"
                   id="inputEmail"
                   name="email"
                   placeholder="Email address"
                   type="text"
                   v-bind:class="[this.email.validated ? this.email.valid ? 'is-valid' : 'is-invalid' : '']"
                   v-model="form.email"
                   v-validate="'required|email'">
            <label for="inputEmail">E-mailadres</label>
            <div class="invalid-feedback">{{ errors.first('email') }}</div>
        </div>

        <div class="form-label-group">
            <input class="form-control" data-vv-validate-on="blur" id="inputPassword"
                   name="password" placeholder="Password"
                   type="password"
                   v-bind:class="[this.password.validated ? this.password.valid ? 'is-valid' : 'is-invalid' : '']"
                   v-model="form.password"
                   v-validate="'required'">
            <label for="inputPassword">Wachtwoord</label>
            <div class="invalid-feedback">{{ errors.first('password') }}</div>
        </div>

        <div class="custom-control custom-checkbox mb-3">
            <input class="custom-control-input" id="customCheck1" type="checkbox">
            <label class="custom-control-label" for="customCheck1">Wachtwoord onthouden</label>
        </div>
        <button :disabled="loading"
                class="btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2"
                type="submit"><span v-if="!loading">Aanmelden</span>
            <div v-else>
                                            <span aria-hidden="true" class="spinner-border spinner-border-sm"
                                                  role="status"></span>
                Laden...
            </div>
        </button>
        <div class="text-center">
            <router-link :to="{name: 'forgot'}" class="small">Wachtwoord vergeten?</router-link>
        </div>
    </form>
</template>
<script>
    import {mapFields} from 'vee-validate'

    export default {
        name: 'Login',
        data() {
            return {
                form: {
                    email: '',
                    password: '',
                    rememberMe: false
                },
                loading: false
            }
        },
        computed: {
            ...mapFields(['email', 'password'])
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        this.$store.dispatch('login', {email: this.form.email, password: this.form.password})
                            .then(() => {
                                this.$router.push({name: 'dashboard'})
                            })
                            .catch((error) => {
                                this.loading = false

                                if (error.errors.email) {
                                    this.$validator.errors.add({
                                        field: 'password',
                                        msg: error.errors.email[0]
                                    })
                                    this.fieldsVee.password.valid = false
                                }
                            })
                    }
                })
            }
        }
    }
</script>
